export class AggregatedData {
  constructor(data = {}) {
    this.savedCounty = data?.savedCounty ?? '';
    this.savedAddress = data?.savedAddress ?? '';
    this.currLoanTerm = data?.currLoanTerm ?? '';
    this.currDueDate = data?.currDueDate ?? '';
    this.user_credit = data?.user_credit ?? '';
    this.refiReason = data?.refiReason ?? '';
  }
}
